const state = {
  panelState: '',

  panelContent: {
    country: '',
    city: '',
    intro: '',
    population: '',
    cars: '',
    bikelanes: '',
    publictransport: '',
    waste: '',
    co2emission: '',
  },

  mapInteractive: false,
};

const mutations = {
  togglePanelState(state, value) {
    if (value === 'onMap') {
      state.panelState = '';
    } 
    else {
      state.panelState = value;
    }
  }, 

  pushPanelContent(state, value) {
    state.panelContent = value;
  },

  toggleMapInteractive(state, value) {
    state.mapInteractive = value;
  }  
};

const actions = {
  updatePanelState({ commit }, value) {
    commit('togglePanelState', value);
  },
  updatePanelContent({ commit }, value) {
    commit('pushPanelContent', value);
  }, 
  updateMapState({ commit }, value) {
    commit('toggleMapInteractive', value);
  },                  
};

const getters = {
  panelState: state => state.panelState,
  panelContent: state => state.panelContent,
  mapInteractive: state => state.mapInteractive,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
